import { validateReadingEvidenceConfig } from '../minigames/reading-evidence/ReadingEvidenceConfig.js';

export const INFERENCE_HOLLOW_PASSAGE = validateReadingEvidenceConfig({
  id: 'inference-hollow-wet-pawprints',
  skillId: 'literacy.inference.text-clues',
  title: 'Clues Before Sunrise',
  pages: [
    'Leni reached the hollow oak before sunrise. The sky was clear, but a line of wet pawprints led from the stream to the tree.',
    'Inside the hollow, a tiny lantern was still glowing beside a dry leaf blanket. Drops of water sparkled on the floor.',
    'A young fox slept on the blanket. Its fur was damp, its paws were muddy, and it was curled close to the warm lantern.',
  ],
  question: 'What most likely happened before Leni arrived?',
  claimChoices: [
    { id: 'fox-returned-to-rest', text: 'The fox came back wet from the stream and fell asleep in the hollow.' },
    { id: 'leni-made-prints', text: 'Leni made the pawprints and then lit the lantern.' },
    { id: 'fox-planted-flowers', text: 'The fox planted flowers beside the hollow all night.' },
  ],
  evidenceDetails: [
    { id: 'prints-stream-to-tree', pageIndex: 0, text: 'Wet pawprints lead from the stream to the tree.' },
    { id: 'fox-damp-asleep', pageIndex: 2, text: 'The fox is damp and asleep on the blanket.' },
    { id: 'sky-was-clear', pageIndex: 0, text: 'The sky is clear before sunrise.' },
    { id: 'lantern-still-glowing', pageIndex: 1, text: 'A small lantern is still glowing.' },
  ],
  correctClaimId: 'fox-returned-to-rest',
  requiredEvidenceIds: ['prints-stream-to-tree', 'fox-damp-asleep'],
  hints: [
    'An inference combines what the text says with what you know.',
    'Follow the wet clues from the stream into the hollow.',
    'Connect the pawprints with the damp, sleeping fox.',
  ],
  completionWorldEvent: 'inference-hollow-clue-lanterns-lit',
  successMessage: 'The clues fit the inference. Three lanterns light the safe path through the hollow!',
});
